<div class="search-bar">
  <!-- ===================== -->
  <!-- Search Icon (Leading) -->
  <!-- ===================== -->
  <div class="search-icon">
    <img src="/images/icons/search.svg" [alt]="'topNav.search.title' | translate" width="20" height="20" />
  </div>

  <!-- ================= -->
  <!-- Search Input Field -->
  <!-- ================= -->
  <input
    type="text"
    [(ngModel)]="searchQuery"
    [placeholder]="'topNav.search.placeholder' | translate"
    class="search-input"
    (keyup.enter)="applySearch()" />

  <!-- ==================== -->
  <!-- Clear Search Button -->
  <!-- ==================== -->
  <button *ngIf="searchQuery" (click)="clearSearch()" class="clear-button">
    <img src="/images/icons/close.svg" [alt]="'search.clear' | translate" width="16px" height="16px" />
  </button>

  <!-- ================= -->
  <!-- Execute Search CTA -->
  <!-- ================= -->
  <button (click)="applySearch()" class="search-button" [attr.aria-label]="'topNav.search.title' | translate">
    <img src="/images/icons/search.svg" [alt]="'search.title' | translate" width="16px" height="16px" style="filter: brightness(0) invert(1)" />
  </button>

  <!-- ========== -->
  <!-- UI Divider -->
  <!-- ========== -->
  <div class="search-divider"></div>

  <!-- ================= -->
  <!-- Show Filters Button -->
  <!-- ================= -->
  <button (click)="toggleFilters.emit(true)" class="filter-button">
    <img src="/images/icons/sliders.svg" [alt]="'filters.title' | translate" width="16" height="16" />
    @if (activeFiltersCount()) {
      <div class="filter-button__active-filters-count">{{ activeFiltersCount() }}</div>
    }
    <span>{{ "filters.title" | translate }}</span>
  </button>
</div>
